import React, { useEffect, useState } from 'react';
import { Alert, Box } from '@mui/material';
import { apiV2Instance } from '../../common/lib/api-v2.client';
import { deviceLabel } from './device-label';

type QuickLinkGoPageProps = {
  channelName: string;
  linkId: string;
};

export default function QuickLinkGoPage({
  channelName,
  linkId,
}: QuickLinkGoPageProps): JSX.Element {
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    let cancelled = false;
    apiV2Instance
      .post(
        '/api/quick-links/analytics/go',
        {
          channelName,
          linkId,
          marker: 'quickcam-profile',
          device: deviceLabel(),
        },
        { silent: true },
      )
      .then((response) => {
        const url = response.data?.url;
        if (!url) {
          if (!cancelled) setMissing(true);
          return;
        }
        window.location.replace(url);
      })
      .catch(() => {
        if (!cancelled) setMissing(true);
      });
    return () => {
      cancelled = true;
    };
  }, [channelName, linkId]);

  if (missing) return <Alert severity="info">That link is not available.</Alert>;
  return <Box sx={{ minHeight: '40vh' }} />;
}
